import React from 'react'
import PropTypes from 'prop-types'

// Components
import {
    Box,
    SimpleGrid,
    Text,
    Link,
    VStack
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'

// Hooks
import useMultiSite from '@app/hooks/use-multi-site'

export const PDCDeliveryOption = ({
    deliveryOptionTitle,
    deliveryOptionColumnOne,
    deliveryOptionColumnTwo,
    deliveryOptionLinkUrl,
    deliveryOptionLinkLabel,
    deliveryOptionIsExternal = false
}) => {
    const {buildUrl} = useMultiSite()

    const linkProps = deliveryOptionIsExternal
        ? {
              href: deliveryOptionLinkUrl,
              isExternal: deliveryOptionIsExternal
          }
        : {
              to: buildUrl(deliveryOptionLinkUrl),
              as: RouteLink
          }

    return (
        <VStack gap={16} alignItems="stretch">
            <Text textTransform="uppercase" fontWeight="bold" fontSize={14}>
                {deliveryOptionTitle}
            </Text>

            <SimpleGrid columns={2} gap={32}>
                <Box fontSize={12} dangerouslySetInnerHTML={{__html: deliveryOptionColumnOne}} />
                <Box fontSize={12} dangerouslySetInnerHTML={{__html: deliveryOptionColumnTwo}} />
            </SimpleGrid>

            <Box>
                {deliveryOptionLinkUrl && (
                    <Link
                        variant="secondary"
                        size="sm"
                        isExternal={deliveryOptionIsExternal}
                        {...linkProps}
                    >
                        {deliveryOptionLinkLabel}
                    </Link>
                )}
            </Box>
        </VStack>
    )
}

PDCDeliveryOption.propTypes = {
    deliveryOptionTitle: PropTypes.string.isRequired,
    deliveryOptionColumnOne: PropTypes.string.isRequired,
    deliveryOptionColumnTwo: PropTypes.string.isRequired,
    deliveryOptionLinkUrl: PropTypes.string,
    deliveryOptionLinkLabel: PropTypes.string,
    deliveryOptionIsExternal: PropTypes.bool
}
